<script setup lang="ts">
import type { CookieApp } from '../types/cookies';
import Copyright from './Copyright.vue';

const props = defineProps<{
	app?: CookieApp;
}>();
</script>

<template>
	<div class="backdrop">
		<div class="backdrop__media">
			<img class="backdrop__image" src="../assets/images/entry/no-backdrop.png" aria-hidden="true" role="presentation" />
		</div>
		<div class="backdrop__footer">
			<Copyright :app="props.app" has-help />
			<!-- <div class="backdrop__author">
				<span class="backdrop__label">Artwork by John Doe</span>
				<HmButtonLink
					label="Learn more"
					icon="arrow-square-out"
					to="/"
					is-primary
					is-bold
					size="sm"
				/>
			</div> -->
		</div>
	</div>
</template>
